import React from "react";
import PropTypes from "prop-types";
import { SwipeableViews, PlayerProfilePreview } from "../..";
import "./TeamMembersSwiper.scss";

const TeamMembersSwiper = ({
  teamMembers,
  teamName,
  teamImage,
  getCurrentTeamMember,
  currentTeamMemberId,
  isWithTeam,
  hasDetails,
  slidesToShow,
  customStyle,
  isGreenArrow,
  handleMemberClick
}) => {
  const playerIndex =
    teamMembers &&
    teamMembers.findIndex(item => item._id === currentTeamMemberId);
  return (
    <div className={customStyle || "team-members-swiper"}>
      <div className="team-members-swiper__container">
        {teamMembers &&
          teamMembers.length > 0 && (
            <SwipeableViews
              handleSwipe={index => getCurrentTeamMember(index)}
              hasDots={false}
              isSwipeable={false}
              isGreenArrow={isGreenArrow}
              isInfinite
              index={playerIndex + 1}
              slidesToShow={slidesToShow}
            >
              {isWithTeam && (
                <PlayerProfilePreview
                  key={teamName}
                  avatar={teamImage}
                  fullName={teamName}
                  playerNumber="All Team"
                  hasDetails={hasDetails}
                />
              )}
              {teamMembers.map(member => (
                <PlayerProfilePreview
                  key={member._id}
                  avatar={member.avatar}
                  avatarBgColor={member.avatarBgColor}
                  lastName={member.lastName}
                  firstName={member.firstName}
                  fullName={member.fullName}
                  playerNumber={member.playerNumber}
                  hasDetails={false}
                  handleMemberClick={()=>handleMemberClick(member._id)}
                  // data-testid='team-member-'
                />
              ))}
            </SwipeableViews>
          )}
      </div>
    </div>
  );
};

TeamMembersSwiper.propTypes = {
  hasDetails: PropTypes.bool,
  isWithTeam: PropTypes.bool,
  teamImage: PropTypes.string,
  teamMembers: PropTypes.array,
  teamName: PropTypes.string
};

TeamMembersSwiper.defaultProps = {
  hasDetails: true,
  isWithTeam: true,
  teamImage: "",
  teamMembers: [],
  teamName: ""
};

export default TeamMembersSwiper;
